import left from './assets/landscape/02-near-right.svg';
import right from './assets/landscape/03-middle-right.svg';
import './gameCard.css';

export const gameCard = { left, right };
